<template>
  <div>
    <Accordion
      v-for="(item, sectionIndex) in countryData"
      :key="sectionIndex"
      :full="true"
      :active="true"
      :dir-button="true"
      :title="item.title"
    >
      <div class="main__featured section section-border--top">
        <client-only>
          <ReportSlider :slides="item.jurisdictions" :slide-nav="jurisdictionNavItems" />
        </client-only>
      </div>

    </Accordion>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ReportCountryScrollable",
  components: {
    Accordion: () => import("../elements/Accordion"),
    ReportSlider: () => import("../elements/ReportSlider"),
  },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    jurisdictions: {
      type: Array,
      default: () => [],
    },
    chosenJurisdictions: {
      type: Array,
      default: () => [],
    },
    chosenSections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      jurisdictionNavItems: [],
    };
  },
  computed: {
    ...mapState("ReportBuilder", ["countryData"]),
    ...mapState("Global", ["isoCodes"]),
  },
  created() {
    const sections = this.sections.filter((s) =>
      this.chosenSections.includes(s.name)
    );

    const jurisdictions = this.jurisdictions.filter((s) =>
      this.chosenJurisdictions.some((cj) => cj.name === s.text)
  );

    this.jurisdictionNavItems = this.chosenJurisdictions.map((item, key) => ({
      id: key,
      name: item.name,
      checked: key < 3,
      iso: item.iso,
      flagUrl: item.flagUrl,
    }));

    let queryParams = sections.map((s) => "filter[tid][]=" + s.tid);
    queryParams = queryParams.concat(
      jurisdictions.map((j) => "filter[jid][]=" + j.value)
    );

    this.$store
      .dispatch("ReportBuilder/getViewData", {
        url: "/report-builder/guide-sections?" + queryParams.join("&"),
      })
      .then(({ data }) => {
        this.$store.commit("ReportBuilder/setData", {
          label: "countryData",
          data,
        });
        const links = [];
        data.forEach((d) => {
          d.jurisdictions.forEach((j) => {
            j.related_guides.forEach((r) => {
              if (!links.some((l) => l.title === r.title)) {
                links.push(r);
              }
            });
          });
        });
        this.$emit("updateSidebarLinks", links);
      })
      .catch((error) => console.error("ERROR:", error));
  },
  methods: {
    findIso(countryName) {
      const isoCode = this.isoCodes.find((el) => el.name === countryName);
      if (isoCode) return isoCode["alpha-2"];

      return null;
    },
    handleChange(item) {
      // const checkedCount = this.jurisdictionNavItems[item].filter(
      //   (checkbox) => checkbox
      // ).length;
      // if (checkedCount > 3) {
      //   this.jurisdictionNavItems[item].checked = false;
      // }
    },
    hasBeenSelected(itemName) {
      const found = this.jurisdictionNavItems.find(
        (obj) => obj.name === itemName
      );

      if (found.checked) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
.el-tabs {
  &__header {
    padding-top: 10px !important;
  }
}
</style>

<style scoped lang="scss">
.el-tabs {
  padding-left: 4rem;
  border-left: 1px dotted gray;

  &__item {
    margin-top: 2rem;
    > span {
      font-weight: 700;
    }

    &.is-active {
      border-bottom: 1px solid red !important;
    }
  }
}
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.country__icon {
  height: 2.5rem;
  width: 2.5rem;
  display: inline-block;
  padding-right: 1rem;

  img {
    width: 100%;
  }
}

.horizscroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  white-space: nowrap;
}

.inner {
  flex-shrink: 0;
  height: 100%;
  padding: 1rem;
  box-sizing: border-box;
  overflow: hidden;
  word-wrap: break-word;
  flex-direction: column;

  &__content {
    flex: 1;
    padding: 16px;
    width: 470px;

    &p {
      word-wrap: break-word;
    }
  }

  table {
    width: 200px !important;
  }
}

//.requirements-wrapper {
// If we want the container in which the columns of content reside to be scrollahble horizotally
// uncomment the line below

// overflow-x: scroll;
// }

.requirements-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 10px;
}

.requirements-column {
  padding: 10px;
}

.inner-column {
  height: 100px;
}

.requirements-nav-checkbox {
  cursor: pointer;
}

nav {
  text-align: center;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid $borderLine;
}
</style>
